export default __webpack_public_path__ + "images/0964477ac2564ecf9253712ca77c7710.svg";